import React from 'react';
import { isoPad } from './helpers';
import { literals } from './constants';

export const SortDropdown = (props) => {
  const options = {
    'timestamp': literals.timestamp[props.locale],
    '1x2'      : literals.turnover_1x2[props.locale],
    '1m'       : literals.turnover_1m[props.locale],
    'Xm'       : literals.turnover_Xm[props.locale],
    '2m'       : literals.turnover_2m[props.locale],
    '1'        : literals.odd_1[props.locale],
    'X'        : literals.odd_X[props.locale],
    '2'        : literals.odd_2[props.locale],
    'ou'       : literals.odd_ou[props.locale],
    'um'       : literals.turnover_um[props.locale],
    'om'       : literals.turnover_om[props.locale],
    'u'        : literals.odd_u[props.locale],
    'o'        : literals.odd_o[props.locale],
  }
  return(
    <div className="filter-item">
      <span>{literals.sortLabel[props.locale]}</span>
      <select defaultValue="1x2" onChange={props.handleSortChange}>
        {
          Object.keys(options).map((key)=>{
            return <option key={key} value={key}>{options[key]}</option>
          })
        }
      </select>
    </div>
  );
}

export const TimezoneDropdown = (props) => {
  let options = {};
  for (let i=-12; i<=12; i++) {
    options[i] = `GMT${isoPad(i)}`
  }
  return(
    <div className="filter-item">
      <span>{literals.timezone_label[props.locale]}: </span>
      <select onChange={props.handleTimezoneChange} defaultValue={props.defaultValue}>
        {
          Object.keys(options).map( (key)=>
            <option key={`option${key}`} value={key}>
              {options[key]}
            </option>
          )
        }
      </select>
    </div>
  );
}

export const OddsFormatDropdown = (props) => {
  let options = {
    'dec' : literals.dec[props.locale],
    'fra' : literals.fra[props.locale],
    'mon' : literals.mon[props.locale]
  };
  return(
    <div className="filter-item">
      <span>{literals.odds_label[props.locale]} :</span>
      <select defaultValue={props.defaultValue} onChange={props.handleOddsFormatChange}>
        {
          Object.keys(options).map( (key) => 
            <option key={`option${key}`} value={key}>
              {options[key]}
            </option>
          )
        }
      </select>
    </div>
  );
}

export const CurrencyDropdown = (props) => {
  let options = {
    'EUR' : `${literals.eur[props.locale]} (€)`,
    'GBP' : `${literals.gbp[props.locale]} (£)`,
    'USD' : `${literals.usd[props.locale]} ($)`
  };
  return(
    <div className="filter-item">
      <span>{literals.currency_label[props.locale]} :</span>
      <select defaultValue={props.defaultValue} onChange={props.handleCurrencyChange}>
        {
          Object.keys(options).map( (key) => 
            <option key={`option${key}`} value={key}>
              {options[key]}
            </option>
          )
        }
      </select>
    </div>
  );
}



export const Loader = (props) => {
  return (
    <div className="spinner">
      <div className="dot1"></div>
      <div className="dot2"></div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components.js